import ApplicationModel, { attr } from '../ApplicationModel';
import { type DiscoveryFileAttributes } from './generated/DiscoveryFileAttributes';
import { model } from '../modelBuilder';

interface DiscoveryFile extends DiscoveryFileAttributes {}

@model
class DiscoveryFile extends ApplicationModel {
  // Start auto-generated
  static typename: 'DiscoveryFile' = 'DiscoveryFile';
  get typename(): 'DiscoveryFile' {
    return 'DiscoveryFile';
  }

  static internalTypename: 'Discovery::File' = 'Discovery::File';
  get internalTypename(): 'Discovery::File' {
    return 'Discovery::File';
  }

  static inputType = 'DiscoveryFileAttributes!';

  static filterType = 'DiscoveryFileFilters!';
  static filters = {
    id: '[ID!]',
    discoveryStudyId: '[ID!]',
    projectId: '[ID!]',
  };

  static fields = {
    aiSummary: attr({ writable: true, readable: true }),
    createdAt: attr({ readable: true }),
    discoveryStudyId: attr({ readable: true }),
    id: attr({ readable: true }),
    name: attr({ writable: true, readable: true }),
    path: attr({ readable: true }),
    projectId: attr({ readable: true }),
    referenceNum: attr({ readable: true }),
    updatedAt: attr({ readable: true }),
    description: attr.belongsTo({ readable: true, typename: 'Note' }),
    discoveryStudy: attr.belongsTo({
      readable: true,
      typename: 'DiscoveryStudy',
    }),
    project: attr.belongsTo({ readable: true, typename: 'Project' }),
  };
  // End auto-generated
}

export default DiscoveryFile;
